<template lang="pug">
.recent-chat-wrapper(v-if="messagesLoaded")
  .header Recent chat messages
  .scroll-wrapper
    template(v-if="recentCoachingMessages.length > 0")
      .message(
        v-for="message in recentCoachingMessages"
        :class="{ 'has-supervisor-review': lastSupervisorReview && lastSupervisorReview > message.sentOn }")
        b {{ messageTypeToSimpleString(message.type) }}:&nbsp;
        | - {{ message.sentOn | longDate }}:
        br
        | {{ message.message | entityToText }}
    template(v-else)
      .message
        b No recent messages between this user and their coach.
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'CoachingRecentChat',
  props: {
    patientId: {
      type: Number,
      required: true
    },
    lastSupervisorReview: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      messagesLoaded: false
    };
  },
  computed: {
    ...mapGetters(['recentCoachingMessages'])
  },
  methods: {
    init() {
      this.getRecentCoachingMessages(this.patientId).then(() => {
        this.messagesLoaded = true;
      });
    },
    messageTypeToSimpleString(type) {
      if (type === 'TO_COACH') {
        return 'User';
      } else if (type === 'FROM_COACH') {
        return 'Coach';
      }
      return type;
    },
    ...mapActions([
      'getRecentCoachingMessages'
    ])
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.recent-chat-wrapper {
  margin-bottom: 0.5em;

  .header {
    font-size: 0.8em;
    font-weight: 600;
    text-transform: uppercase;
    border-top: 1px solid #212121;
    margin: 0 0 .25em 0;
  }

  .scroll-wrapper {
    max-height: 300px;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 2px 10px 0 0;
  }

  .message {
    font-size: 0.8em;
    line-height: 1.2;
    margin-bottom: .5em;
    padding-bottom: .5em;
    border-bottom: 1px solid #ddd;
    word-wrap: break-word;

    &:last-child {
      border-bottom: 0px solid #fff;
    }

    &.has-supervisor-review {
      background-color: $supervisor-review-background;
    }
  }
}
</style>
